/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $marketSubfolder;

  // Private functions
  var getCartItemsWithFabricCuts, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Register Handlebars helper for comparison
    Handlebars.registerHelper('compare', function(lvalue, operator, rvalue, options) {
      var operators, result;
      if (arguments.length < 3) {
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
      }
      if (options === undefined) {
        options = rvalue;
        rvalue = operator;
        operator = "===";
      }
      operators = {
        '==': function(l, r) { return l == r; },
        '===': function(l, r) { return l === r; },
        '!=': function(l, r) { return l != r; },
        '!==': function(l, r) { return l !== r; },
        '<': function(l, r) { return l < r; },
        '>': function(l, r) { return l > r; },
        '<=': function(l, r) { return l <= r; },
        '>=': function(l, r) { return l >= r; },
        'typeof': function(l, r) { return typeof l == r; }
      };
      if (!operators[operator]) {
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
      }
      result = operators[operator](lvalue, rvalue);
      if (result) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      cartUrl            : '/cart'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    $marketSubfolder = "";

    // Split the URL into parts and remove the leading slash
    const cartPathParts = settings.cartUrl.replace(/^\//, "").split("/");

    if (Array.isArray(cartPathParts) && cartPathParts.length > 1)
      $marketSubfolder = cartPathParts[0];

    if ($marketSubfolder.charAt(0) === "/")
      $marketSubfolder = $marketSubfolder.substring(1, $marketSubfolder.length);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors)
      qtySelectors();

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length)
      formOverride();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  // Replace any Fabric Cut cart item quantities with
  // 1, i.e. 80m isn't 800, it's just 1 (for the user).
  getCartItemsWithFabricCuts = function (cart, items = []) {
    if (!items.length || items.length == 0) {
      $.each(cart.items, function(index, cartItem) {
        let sku_type = cartItem.sku.split('+');

        items.push({
          itemQty: cartItem.quantity,
          isFabricCut: cartItem.product_type == 'Fabric' && sku_type[1] == 'M'
        });
      });
    }

    var cartItemCount = cart.item_count;
    items.forEach(item => {
      if (item.isFabricCut)
        cartItemCount -= (item.itemQty - 1);
    });

    return cartItemCount;
  }

  updateCountPrice = function (cart) {
    let cartItemCount = getCartItemsWithFabricCuts(cart);

    if ($cartCountSelector) {
      $cartCountSelector.html(cartItemCount).removeClass('hidden-count');

      if (cartItemCount === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      // Translation fallback for empty cart message (avoid inline Liquid to keep JS parsable)
      var emptyMsg = (window.theme && window.theme.strings && window.theme.strings.cartEmpty) ? window.theme.strings.cartEmpty : 'Your order is currently empty. Time to start shopping...';
      $cartContainer.append('<p>' + emptyMsg + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    var multiplier = $('#price-multiplier').val();

    var subtotalPrice = cart.original_total_price * multiplier;
    var totalPrice = cart.total_price * multiplier;
    var totalDiscount = cart.total_discount * multiplier;

    if (multiplier > 1) {
      subtotalPrice = Math.ceil((subtotalPrice / 100).toFixed(2)) * 100;
      totalPrice = Math.ceil((totalPrice / 100).toFixed(2)) * 100;
      totalDiscount = Math.ceil((totalDiscount / 100).toFixed(2)) * 100;
    }

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_small$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      if (cartItem.properties !== null) {
        // Expose hidden underscore properties we need before pruning
        if (cartItem.properties._in_stock && !cartItem.properties.in_stock) {
          cartItem.properties.in_stock = cartItem.properties._in_stock;
        }
        if (cartItem.properties._expected_date && !cartItem.properties.expected_date) {
          cartItem.properties.expected_date = cartItem.properties._expected_date;
        }
        if (cartItem.properties._max && !cartItem.properties.max) {
          cartItem.properties.max = cartItem.properties._max;
        }
          if (cartItem.properties._min_required_length && !cartItem.properties.min_required_length) {
          cartItem.properties.min_required_length = cartItem.properties._min_required_length;
        }
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = Shopify.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = Shopify.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
        }
      }

      if ( cartItem.unit_price )
        var unitPrice = Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat);
      else
        var unitPrice = '';

      if (cartItem.unit_price_measurement) {
        var unitPriceMeasurement = cartItem.unit_price_measurement,
        unitPriceBaseUnit = cartItem.unit_price_measurement.reference_unit,
        unitReferenceValue = cartItem.unit_price_measurement.reference_value,
        showUnitReferenceValue = cartItem.unit_price_measurement.reference_value != 1 ? false : true;
      } else {
        var unitPriceMeasurement = '',
        unitPriceBaseUnit = '',
        unitReferenceValue = '',
        showUnitReferenceValue = false;
      }

      if (cartItem.selling_plan_allocation) {
        var sellingPlanAllocation = cartItem.selling_plan_allocation.selling_plan,
        sellingPlanAllocationName = cartItem.selling_plan_allocation.selling_plan.name;
      } else {
        var sellingPlanAllocation = false,
        sellingPlanAllocationName = false;
      }

      let sku_type = cartItem.sku.split('+');
      var isFabricCut = cartItem.product_type == 'Fabric' && sku_type[1] == 'M';
      var isSample = cartItem.product_type == 'Samples';

      if (cartItem.properties && typeof cartItem.properties !== 'undefined') {
        var in_stock = 0;
        if (isFabricCut)
          in_stock = parseInt(cartItem.properties["Metres in stock"]) * 10;
        else
          in_stock = cartItem.properties.in_stock;
  
        var variantDispatch = cartItem.quantity;
        var variantBackorder = 0;
        var showStockMessage = false;
        if (cartItem.quantity > in_stock) {
          variantDispatch = in_stock;
          variantBackorder = cartItem.quantity - in_stock;
          showStockMessage = true;
        }
      }

      // Determine maxStock from variant metafields, falling back to _max property
      var maxStock = null;
      var expectedDate = null;
      var minLength = null;
      if (!isFabricCut) {
        // First try to get from variant metafields (due_json.totalSellable)
        if (window.variantMetafields && window.variantMetafields[cartItem.variant_id]) {
          var dueJson = window.variantMetafields[cartItem.variant_id].due_json;
          if (dueJson && !isNaN(dueJson.totalSellable)) {
            // Fall back on availableNow if totalSellable is zero or not present
            if (dueJson.totalSellable > 0)
              maxStock = parseInt(dueJson.totalSellable, 10);
            else if (dueJson.availableNow > 0)
              maxStock = parseInt(dueJson.availableNow, 10);
          }
        }
        // Fall back to properties.max if metafield not found
        if (maxStock === null && cartItem.properties && cartItem.properties.max) {
          var parsedMax = parseInt(cartItem.properties.max, 10);
          if (!isNaN(parsedMax)) maxStock = parsedMax;
        }
      }

      if (cartItem.properties && cartItem.properties.expected_date)
        expectedDate = cartItem.properties.expected_date;

      if (cartItem.properties && cartItem.properties.min_required_length) {
        if (cartItem.properties.min_required_length >= maxStock) {
          minLength = maxStock; // If min length amount exceeds the max stock, set min length to max stock
        } else {
          minLength = cartItem.properties.min_required_length;
        }
      }

      // Extract despatch properties for display
      var despatchInfo = [];
      if (cartItem.properties) {
        for (var propKey in cartItem.properties) {
          if (propKey.indexOf('Despatch ') === 0 || propKey === 'Despatch Immediately') {
            despatchInfo.push({
              label: propKey,
              value: cartItem.properties[propKey]
            });
          }
        }
      }

      var price = cartItem.original_line_price * multiplier;
      var unitPrice = cartItem.unit_price * multiplier;
      var discountedPrice = cartItem.final_line_price * multiplier;

      if (multiplier > 1) {
        price = Math.ceil((price / 100).toFixed(2)) * 100;
        unitPrice = Math.ceil((unitPrice / 100).toFixed(2)) * 100;
        discountedPrice = Math.ceil((discountedPrice / 100).toFixed(2)) * 100;
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url.charAt(0) == '/' ? $marketSubfolder == "" ? `${cartItem.url}` : `/${$marketSubfolder}${cartItem.url}` : `/${$marketSubfolder}/${cartItem.url}`,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        isFabricCut: isFabricCut,
        sku: cartItem.sku,
        price: Shopify.formatMoney(
          price,
          settings.moneyFormat
        ),
        unitPrice: Shopify.formatMoney(
          unitPrice,
          settings.moneyFormat
        ),
        unitPriceMeasurement: unitPriceMeasurement,
        unitPriceBaseUnit: unitPriceBaseUnit,
        unitReferenceValue: unitReferenceValue,
        showUnitReferenceValue: showUnitReferenceValue,
        discountedPrice: Shopify.formatMoney(
          discountedPrice,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        sellingPlanAllocation: sellingPlanAllocation,
        sellingPlanAllocationName: sellingPlanAllocationName,
        variantDispatch: variantDispatch,
        variantBackorder: variantBackorder,
        showStockMessage: showStockMessage,
        minLength: minLength,
        despatchInfo: despatchInfo,
        isSample: isSample,
      };

      if (expectedDate !== null) {
        item.expectedDate = expectedDate;
      }
      if (maxStock !== null) {
        item.maxStock = maxStock;
      }

      if (minLength !== null) {
        item.minLength = minLength;
      }

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      totalItems: getCartItemsWithFabricCuts(cart, items),
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(
        subtotalPrice,
        settings.moneyFormat
      ),
      totalPrice: Shopify.formatMoney(
        totalPrice,
        settings.moneyFormat
      ),
      cartTotalDiscounts: Shopify.formatMoney(
        totalDiscount,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0
    };

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $lineContainer = $el.closest('.ajaxcart-container'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));
      
      // Removal isn't necessary as the cart is re-drawn after update
      $lineContainer.addClass('is-loading');

      if ($el[0].classList.contains('quantity-fabric')) {
        qty = parseInt($el[0].parentElement.querySelector('.ajaxcart__qty-num').getAttribute('data-value-actual'));
        const min = parseInt($el[0].parentElement.querySelector('.ajaxcart__qty-num').getAttribute('min'));
        if ($el.hasClass('ajaxcart__qty--plus')) {
          if(qty < min) {
            qty = min;
          }else{
            qty += 1;
          }
        } else {
          if(qty >= min) {
            qty = 0;
          }else {
            qty -= 1;
          }
        }
      } else{
        // Add or subtract from the current quantity
        if ($el.hasClass('ajaxcart__qty--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 0) qty = 0;
        }
      }

      // Enforce max (non-fabric only). If a max attribute is present and would be exceeded, clamp and alert.
      var maxAttr = $qtySelector.attr('max');
      if (maxAttr !== undefined) {
        var maxVal = parseInt(maxAttr, 10);
        if (!isNaN(maxVal) && qty > maxVal) {
          qty = maxVal;
          // Provide simple feedback only once per overrun attempt
          if (!$qtySelector.data('maxAlerted')) {
            alert('Maximum available quantity is ' + maxVal + '.');
            $qtySelector.data('maxAlerted', true);
            setTimeout(function(){ $qtySelector.removeData('maxAlerted'); }, 500); // allow future alerts after short delay
          }
        }
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    //Update item quanity to 0 so the item is removed on bin click
    $body.on('click', '.ajaxcart__qty-remove', function() {
      var $el = $(this),
      line = $el.data('line');

      if(line) {
        updateQuantity(line, 0);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = $el[0].classList.contains('quantity-fabric') ? parseFloat($el.val().replace(/[^0-9.]/g, '')).toFixed(2) : parseInt($el.val().replace(/\D/g, ''));

      if ($el[0].classList.contains('quantity-fabric'))
        qty = Math.round(qty * 10) / 10;

      var qty = validateQty(qty);

      if ($el[0].classList.contains('quantity-fabric'))
        qty *= 10;

      // Enforce max on manual input for non-fabric items
      var maxAttr = $el.attr('max');
      if (maxAttr !== undefined) {
        var maxVal = parseInt(maxAttr, 10);
        if (!isNaN(maxVal) && qty > maxVal) {
          qty = maxVal;
          $el.val(maxVal); // reflect clamped value visually
          alert('Maximum available quantity is ' + maxVal + '.');
        }
      }

      // If it has a data-line, update the cart
      if (line) {
        // Multiply by 10 
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });

    // Toggle despatch information
    $body.on('click', '.ajaxcart__despatch-toggle', function() {
      var $toggle = $(this);
      var line = $toggle.data('line');
      var $details = $('.ajaxcart__despatch-details[data-line="' + line + '"]');
      
      if ($details.is(':visible')) {
        $details.slideUp('fast');
        $toggle.removeClass('active');
      } else {
        $details.slideDown('fast');
        $toggle.addClass('active');
      }
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]').not($('.ignore-js'));

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        // Copy the template from the JsQty element
        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if(!isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));
